const calcMedian = (list, parity) => {
    // if there there is parity (a middle numnber);   i.e. remainder of length / 2 = 0;  odd length
    if ( parity ) {
        const index = Math.floor( list.length / 2 )
        console.log("[PARITY MEDIAN INDEX]: ",  index)
        
        console.log("[PARITY MEDIAN VALUE]: ", list[index]) 
        return list[index]
    }    
    // if there is not parity (a middle number);      i.e. remainder of length / 2 != 0; even length
    const upperIndex = list.length / 2
    const lowerIndex = list.length / 2 - 1
    console.log("[NON-PARITY MEDIAN upperIndex]: ", upperIndex)    
    console.log("[NON-PARITY MEDIAN lowerIndex]: ", lowerIndex)   
    
    console.log("[NON-PARITY MEDIAN]: ", ( list[upperIndex] + list[lowerIndex] ) / 2 )
    return ( ( list[upperIndex] + list[lowerIndex] ) / 2 )
}

export const median = (data) => {
    /*
    NOTE .sort(): 'N/A' compareed to a number in sort will return NaN for that comparator loop, meaning the ordering goes garbage, and breaks everything else down stream
        1) NaN fails every comparison
            NaN < 0 is false
            NaN > 0 is false
            NaN === 0 is false
        2) So the engine gets no usable signal for that pair and can't place them relative to each other
        3) The  elements don't get reliably ordered, and the final array order is effectively indeterminate
    */
    console.log("[ENTERING MEDIAN MAIN ORCHESTRATION SERVICE]")
    
    //Step 1: Normalize
    const sorted      = data.sort((a, b) => a - b);
    //Step 2: Enrich - new derivative variable based on data - remainder of length / 2 === 0, then there no middle (i.e. 10 / 5 = 2 remainder 0, so no middle number and have to take the two middle numbers and divide by 2)
    const isParity    = sorted.length % 2 === 0 ? false : true
    //Step 3: Project
    return calcMedian(sorted, isParity)
}
